'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Captcha = require('@/components/Captcha');

var _Captcha2 = _interopRequireDefault(_Captcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Captcha: _Captcha2.default
    },
    props: ['buffer', 'network'],
    data: function data() {
        return {
            forceLoader: false,
            captchaReady: false
        };
    },

    computed: {
        netStatus: function netStatus() {
            return this.buffer.getNetwork().state;
        },
        shouldShowLoading: function shouldShowLoading() {
            this.maybeForceLoader();

            if (this.network.state !== 'disconnected' || this.forceLoader) {
                return true;
            }

            return false;
        },
        restrictedServer: function restrictedServer() {
            return this.$state.setting('restricted');
        },
        readyToStart: function readyToStart() {
            return this.captchaReady;
        }
    },
    methods: {
        maybeForceLoader: function maybeForceLoader() {
            var _this = this;

            var minimumLoaderViewtime = 2000;
            var networkState = this.network.state;

            if (networkState !== 'disconnected' && !this.forceLoader) {
                this.forceLoader = true;
                setTimeout(function () {
                    _this.forceLoader = false;
                }, minimumLoaderViewtime);
            }
        },
        isChannel: function isChannel() {
            return this.buffer.isChannel();
        },
        isServer: function isServer() {
            return this.buffer.isServer();
        },
        isQuery: function isQuery() {
            return this.buffer.isQuery();
        },
        reconnect: function reconnect() {
            if (!this.readyToStart) {
                return;
            }
            if (this.buffer.isChannel()) {
                this.buffer.enabled = true;
            }
            this.buffer.getNetwork().ircClient.connect();
        },
        showNetworkSettings: function showNetworkSettings() {
            var network = this.buffer.getNetwork();
            network.showServerBuffer('settings');
        },
        handleCaptcha: function handleCaptcha(isReady) {
            this.captchaReady = isReady;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NotConnected"]
window._kiwi_exports.components.NotConnected = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotConnected.vue
// module id = 4Ost
// module chunks = 1